// Notifications.js

import { ComponentBase } from "../core/ComponentBase.js";

export class Notifications extends ComponentBase {
  static styles = `
    /* Container for the dropdown notifications */
    .notifications-container {
      position: relative;
      display: inline-block;
    }

    /* Notification badge uses Bootstrap theme variables */
    .notification-badge {
      position: absolute;
      top: 0;
      right: 0;
      transform: translate(50%, -50 %);
      background-color: var(--bs-primary);
      color: var(--bs-danger-text-emphasis, #fff);
      border-radius: 50%;
      padding: 2px 6px;
      font-size: var(--ab-text-xs);
      line-height: 1;
    }

    /* Custom dropdown menu styles */
    .notifications-dropdown-menu {
      max-height: 300px;
      min-width: 300px;
      max-width: 300x;
      overflow-y: auto;
      width: 300px;
      background-color: var(--bs-dropdown-bg, #fff);
      color: var(--bs-dropdown-color, #212529);
      border: 1px solid var(--bs-dropdown-border-color, rgba(0,0,0,.15));
      border-radius: var(--bs-dropdown-border-radius, 0.25rem);
      box-shadow: var(--bs-dropdown-box-shadow, 0 0.5rem 1rem rgba(0,0,0,.175));
      padding: 0.5rem;
    }

    /* Notification item style */
    .notification-item {
      cursor: pointer;
      padding: 0.5rem 1rem;
      white-space: nowrap;
      text-wrap: wrap;
    }
    .notification-item:not(:last-child) {
      border-bottom: 1px solid var(--bs-dropdown-divider-bg, #eee);
    }
    .notification-item:hover {
      background-color: var(--bs-dropdown-link-hover-bg, #f8f9fa);
      color: var(--bs-dropdown-link-hover-color, inherit);
    }
    .notification-item:active {
      background-color: var(--bs-dropdown-link-active-bg, var(--bs-primary));
      color: var(--bs-dropdown-link-active-color, #fff);
    }

    .dropdown-toggle::after {
      display: none !important;
    }


    /* Mobile-first adjustments: force full width for dropdown on small screens */
@media (max-width: 576px) {
 /*.notifications-dropdown-menu {
    position: absolute !important;
    top: 100% !important;
    left: 0 !important;
    right: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    transform: none !important;
    border-radius: 0 !important;
    z-index: var(--ab-z-backdrop);
  }*/
  
  .notifications-container {
    width: 100% !important;
    text-align: center !important;
  }
}

  `;

  constructor(config) {
    super(config);
    this.appClient = config.appClient;
    this.notifications = [];
    this.unreadCount = 0;
    this.isInitialized = false;
    this.applyStyles();
  }

  async initAfterLogin() {
    if (!this.isInitialized) {
      this.log.info("Initializing Notifications component");
      // Fetch initial notifications. If no container exists yet, updateDropdownContent will simply skip UI update.
      await this.fetchNotifications();

      // Subscribe to new notifications events.
      this.appClient.events.server.on("new-notification", (notification) => {
        this.handleNewNotification(notification);
      });
      this.isInitialized = true;
    }
  }

  async initialize() {
    await super.initialize();
  }

  async render() {
    // Create or clear the container element.
    if (!this.container) {
      this.container = document.createElement("div");

      const container = this.container;
      container.innerHTML = "";
      container.classList.add("notifications-container", "dropdown");

      // Create the toggle button with a bell icon and unread badge.
      const toggleButton = document.createElement("button");
      toggleButton.classList.add("btn", "dropdown-toggle", "notification-button", "position-relative");
      toggleButton.type = "button";
      toggleButton.setAttribute('title', 'Notifications');
      toggleButton.setAttribute("data-skip-text", true);
      toggleButton.setAttribute("data-bs-toggle", "dropdown");
      toggleButton.setAttribute("aria-expanded", "false");

      const icon = document.createElement("i");
      icon.classList.add("bi", "bi-bell-fill");

      toggleButton.appendChild(icon);

      const badge = document.createElement("span");
      badge.classList.add("notification-badge");
      badge.textContent = this.unreadCount;
      badge.style.display = this.unreadCount > 0 ? "inline-flex" : "none";
      toggleButton.appendChild(badge);

      container.appendChild(toggleButton);

      // Create the dropdown menu container for notifications.
      this.dropdownMenu = document.createElement("div");
      // Insert the notifications list.
      container.appendChild(this.dropdownMenu);
    }

    this.dropdownMenu.innerHTML = "";
    this.dropdownMenu.classList.add("dropdown-menu", "dropdown-menu-end", "notifications-dropdown-menu");
    this.dropdownMenu.appendChild(this.renderNotificationsList());
    return this.container;
  }

  renderNotificationsList() {
    // A wrapper for notification items.
    const content = document.createElement("div");
    content.classList.add("notifications-content");

    // --- Mobile Fullscreen Header ---
    if (window.innerWidth < 768) {
      const mobileHeader = document.createElement("div");
      mobileHeader.className = "dropdown-header-row d-flex justify-content-between align-items-center border-bottom pb-2 mb-2 w-100";
      mobileHeader.innerHTML = `
          <span class="fw-bold text-body">Notifications</span>
          <button type="button" class="btn-close" data-action="close-dropdown" aria-label="Close"></button>
      `;
      mobileHeader.querySelector('[data-action="close-dropdown"]').addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const dropdownToggle = this.container.querySelector('[data-bs-toggle="dropdown"]');
          if (dropdownToggle) {
              const dropdownInstance = bootstrap.Dropdown.getInstance(dropdownToggle);
              if (dropdownInstance) dropdownInstance.hide();
          }
      });
      content.appendChild(mobileHeader);
    }

    if (this.notifications.length === 0) {
      const noNotif = document.createElement("p");
      noNotif.classList.add("m-0", "p-2", "text-muted");
      noNotif.textContent = this.t("No new notifications.");
      noNotif.setAttribute("data-i18n", "No new notifications.");

      content.appendChild(noNotif);
    } else {
      // Create notification items.
      this.notifications.forEach((notification) => {
        const item = document.createElement("div");
        item.classList.add("notification-item", "d-flex", "align-items-start");
        if (!notification.read) {
          item.classList.add("fw-bold");
        }
        if (notification.icon) {
          const notifIcon = document.createElement("i");
          notifIcon.className = `${notification.icon} me-2`;
          item.appendChild(notifIcon);
        }
        const textContainer = document.createElement("div");
        textContainer.innerHTML = `<strong>${notification.title}</strong><br>${notification.message}`;
        item.appendChild(textContainer);

        item.addEventListener("click", () => {
          this.handleNotificationClick(notification);
          // Close the dropdown after clicking an item.
          const dropdownInstance = bootstrap.Dropdown.getInstance(
            this.container.querySelector(".dropdown-toggle")
          );
          if (dropdownInstance) {
            dropdownInstance.hide();
          }
        });

        content.appendChild(item);
      });
    }

    // Create actions container for "Clear All" and "Mark All as Read" buttons.
    const actionsContainer = document.createElement("div");
    actionsContainer.classList.add("d-flex", "justify-content-end", "mt-2");

    const clearAllButton = document.createElement("button");
    clearAllButton.classList.add("btn", "btn-outline-secondary", "btn-sm");
    clearAllButton.textContent = "Clear All";
    clearAllButton.setAttribute("data-i18n", clearAllButton.textContent);
    clearAllButton.addEventListener("click", async (e) => {
      e.stopPropagation();
      await this.clearAllNotifications();
      this.updateDropdownContent();
    });
    actionsContainer.appendChild(clearAllButton);

    const markAllReadButton = document.createElement("button");
    markAllReadButton.classList.add("btn", "btn-outline-secondary", "btn-sm", "ms-2");
    markAllReadButton.textContent = "Mark All as Read";
    markAllReadButton.setAttribute("data-i18n", markAllReadButton.textContent);

    markAllReadButton.addEventListener("click", async (e) => {
      e.stopPropagation();
      await this.markAllAsRead();
      this.updateDropdownContent();
    });
    actionsContainer.appendChild(markAllReadButton);

    content.appendChild(actionsContainer);
    return content;
  }

  updateDropdownContent() {
    // Only update if the container exists.
    if (this.dropdownMenu) {
      this.dropdownMenu.innerHTML = "";
      this.dropdownMenu.appendChild(this.renderNotificationsList());
    }
    if (this.container) {
      const badge = this.container.querySelector(".notification-badge");
      if (badge) {
        badge.textContent = this.unreadCount;
        badge.style.display = this.unreadCount > 0 ? "inline-flex" : "none";
      }
    }
  }

  async fetchNotifications() {
    try {
      const response = await this.appClient.rpcClient.call("NotificationRpc.getData", {
        filter: {},
        context: this.appClient.getSharedData("context")
      });
      if (response.data) {
        this.notifications = response.data;
        this.unreadCount = this.notifications.filter((n) => !n.read).length;
      } else {
        this.notifications = [];
        this.unreadCount = 0;
      }
      this.updateDropdownContent();
    } catch (error) {
      this.log.error("Error fetching notifications:", error);
      this.appClient.notifier.notify("Error fetching notifications", { type: "error" });
    }
  }

  handleNewNotification(notification) {
    this.notifications.unshift(notification);
    this.unreadCount++;
    this.updateDropdownContent();
    if (document.hidden) {
      this.showDesktopNotification(notification);
    }
  }

  async handleNotificationClick(notification) {
    if (!notification.read) {
      try {
        await this.appClient.rpcClient.call("NotificationRpc.markAsRead", {
          _id: notification._id
        });
        this.unreadCount--;
        notification.read = true;
        this.updateDropdownContent();
      } catch (error) {
        this.log.error("Error marking notification as read:", error);
        this.appClient.notifier.notify("Error marking notification as read", { type: "error" });
      }
    }
    if (notification.action) {
      this.appClient.layoutEngine.navigate(notification.action);
    }
  }

  async clearAllNotifications() {
    try {
      await this.appClient.rpcClient.call("NotificationRpc.deleteAll");
      this.notifications = [];
      this.unreadCount = 0;
      this.updateDropdownContent();
    } catch (error) {
      this.log.error("Error clearing notifications:", error);
      this.appClient.notifier.notify("Error clearing notifications", { type: "error" });
    }
  }

  async markAllAsRead() {
    try {
      await this.appClient.rpcClient.call("NotificationRpc.markAllAsRead");
      this.notifications.forEach((n) => (n.read = true));
      this.unreadCount = 0;
      this.updateDropdownContent();
    } catch (error) {
      this.log.error("Error marking notifications as read:", error);
      this.appClient.notifier.notify("Error marking notifications as read", { type: "error" });
    }
  }

  async showDesktopNotification(notification) {
    if (!("Notification" in window)) {
      this.log.warn("This browser does not support desktop notification");
      return;
    }

    const isGiven = await this.appClient.permissions.isPermissionGiven('notifications');
    if (isGiven) {
      new Notification(notification.title, {
        body: notification.message,
        icon: notification.icon || null
      });
      return;
    }

    const isDenied = await this.appClient.permissions.isPermissionDenied('notifications');
    if (isDenied) {
      return;
    }

    const result = await this.appClient.permissions.getPermission('notifications');
    if (result.status === 'granted') {
      new Notification(notification.title, {
        body: notification.message,
        icon: notification.icon || null
      });
    }
  }
}
